/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  BuilderUserContext, FormRootSchema,
  FormStateSchema,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';

import { FormState, NumberTypes, whenEditMode } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';

import { SystemVarsSupervisor } from '../../resources/model/system-vars-supervisor.model';

@Injectable()
export class SystemVarsSupervisorTabFormState extends FormState<SystemVarsSupervisor> {
  constructor(private userContext: BuilderUserContext,
              schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  protected buildSchema(model: SystemVarsSupervisor, { root }: FormStateSchema): FormRootSchema {
    const mode = this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Supervisor.EDIT)
      ? FormMode.EditMode
      : FormMode.ViewMode;

    return root({
      enabled: whenEditMode(),
      optimisticLock: true,
      mode,
      children: {
        calendarWarningRequired: void 0,
        calendarWarningDays: { type: NumberTypes.Days },
        autoEmailChangeOrders: void 0,
        estimatorSeeSupervisorReports: void 0,
        supervisorReportsIncludeUnsentOrders: void 0,
      },
    });
  }
}
